import { render, staticRenderFns } from "./HistoryEight2.vue?vue&type=template&id=405e61f6&scoped=true"
import script from "./HistoryEight2.vue?vue&type=script&lang=js"
export * from "./HistoryEight2.vue?vue&type=script&lang=js"
import style0 from "./HistoryEight2.vue?vue&type=style&index=0&id=405e61f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e61f6",
  null
  
)

export default component.exports